// extracted by mini-css-extract-plugin
export default {"greyBtn":"ButtonGrey_greyBtn__uoK8c","btnDisabled":"ButtonGrey_btnDisabled__9+H8b"};